import { render } from "./ScreenBannerBP.vue?vue&type=template&id=9a2d07e0&scoped=true&ts=true"
import script from "./ScreenBannerBP.vue?vue&type=script&lang=ts"
export * from "./ScreenBannerBP.vue?vue&type=script&lang=ts"

import "./ScreenBannerBP.vue?vue&type=style&index=0&id=9a2d07e0&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a2d07e0"]])

export default __exports__